'use client';
import React, { useState } from "react";
import type { FC } from "react";
import Container from "@/layouts/Container.layout"
import { RichTextRenderer } from "@/components/RichTextRenderer/RichTextRenderer";
import RockstarInfo from "@/components/sections/RockstarInfo";
import type { RockstarInfoListSection } from "@/utils/strapi/sections/RockstarInfoList";

const RockstarInfoList: FC<RockstarInfoListSection> = (props: RockstarInfoListSection) => {
  const { title, content, rockstars } = props;

  const rockstarsData = rockstars?.sort((a, b) => // sort rockstars alphabetically
    a?.name < b?.name ? -1 : a?.name > b?.name ? 1 : 0
  );

  if (rockstarsData?.length <= 0) {
    return null;
  }


  return (
    <section className="bg-surface-200 py-12">
      <Container>
        {
          title ? <div className="pb-14 mobile:pb-6"><h3 className="font-headings font-bold text-6xl leading-12 mobile:text-2xl mobile:leading-7">{title}</h3></div> : null
        }
        {
          content ?
            <div className="pb-14 mobile:pb-6">
              <RichTextRenderer content={content} />
            </div>
            : null
        }
        {
          rockstars?.length > 0 ?
            <div className="flex flex-col gap-4 ">
              <section className="grid col-span-12 desktop:grid-cols-4 tablet:grid-cols-2 mobile:grid-cols-2 mobile:gap-7 tablet:gap-10 desktop:gap-10 ">
                {
                  rockstarsData?.map((item: any, i: number) => <div key={`section-blog-${i}`}>
                    <RockstarInfo {...item} type={"ComponentSectionsRockstarInfo"} />
                  </div>)
                }
              </section>
            </div>
            : null
        }
      </Container>
    </section>
  );
};

export default RockstarInfoList;